import ProductsMapFrame from './productsmapFrame.jsx';
import BenefitProducts from './benefitsFrame.jsx'; // rename jsx file?
import MobileMenu from './Benefits/MobileMenu.jsx';
import BannerMarquee from './Frame181/frame181.jsx'

const frameComponentsMap = {
    productsmap: ProductsMapFrame,
    productsmapsingle: ProductsMapFrame,
    benefitproducts: BenefitProducts,
    benefitproductsmobilemenu: MobileMenu,
    bannermarquee: BannerMarquee,
}

export default frameComponentsMap;
